import cookieUtils from 'js-cookie';

import { storeCookie, storeCookieByDate } from './storeCookie';

import type { CookieOptions } from './types';

export default class SingleValueCookie {
  name: string;

  cookieValue: string | undefined;

  /**
   * @param name Cookie name
   *
   * @example
   * let scannerCookie = new Cookie('ssab')
   */
  constructor(name: string) {
    this.name = name;
    this.cookieValue = cookieUtils.get(name);
  }

  /**
   * Gets a value of the cookie
   * @returns Value of the selected key
   */
  getValue(): string | undefined {
    return this.cookieValue;
  }

  /**
   * Sets a cookie value
   * @param value New value to be set
   * @returns this
   */
  setValue(value: string | undefined): this {
    this.cookieValue = value;
    return this;
  }

  /**
   * Stores cookie in the document
   * @param expires Number of days for cookie to be valid for
   * @param options object for optional parameters
   * @returns this
   */
  store(expires: number | null | undefined, options?: CookieOptions): this {
    storeCookie(this.name, this.cookieValue ?? '', expires, options);
    return this;
  }

  /**
   * Stores cookie in the document with absolute expiration date
   * @param expirationDate Cookie expiration date
   * @param options object for optional parameters
   * @returns this
   */
  storeByDate(expirationDate: Date, options?: CookieOptions): this {
    storeCookieByDate(
      this.name,
      this.cookieValue ?? '',
      expirationDate,
      options,
    );
    return this;
  }

  /**
   * Removes the cookie
   */
  remove(): void {
    cookieUtils.remove(this.name);
  }
}
